import { LegacyCard, Spinner, Stack, Text, Thumbnail, Badge } from "@shopify/polaris";
import { ImageMajor } from "@shopify/polaris-icons";
import { SELECT_PRODUCTS_BASED_ON_ALL } from "../../../../../../../constants/selectProductsBasedOn.js";

interface CurrentSelectedProductsCardProps {
  productsCount: number;
  isLoading: boolean;
  handleViewModal?: () => void;
  previewProducts?: Array<{ featuredImage?: string; title: string; id: string }>;
  exceptionList?: string[];
  selectedFilterOption?: string;
}

const CurrentSelectedProductsCard: React.FC<CurrentSelectedProductsCardProps> = ({
  productsCount,
  isLoading,
  handleViewModal,
  previewProducts = [],
  exceptionList = [],
  selectedFilterOption = ''
}) => {
  const shouldShowTagsSelectionThings = selectedFilterOption !== SELECT_PRODUCTS_BASED_ON_ALL;

  return (
    <LegacyCard
      secondaryFooterActions={
        shouldShowTagsSelectionThings
          ? [
            {
              content: "View targeted products",
              onAction: handleViewModal,
              disabled: productsCount === 0 && previewProducts.length === 0
            }
          ]
          : undefined
      }
      title={shouldShowTagsSelectionThings && "Product targeted"}
    >
      <LegacyCard.Section>
        {isLoading ? (
          <Spinner size="small" />
        ) : (
          <Stack vertical>
            <Text variant="bodyMd" as="p">{`${productsCount} product${productsCount > 1 ? 's' : ''}`}</Text>
            {previewProducts.map((product, index) => (
              <div key={index}>
                <Stack wrap={false} alignment="center">
                  <Thumbnail
                    source={product.featuredImage || ImageMajor}
                    alt={product.title}
                    size="small"
                  />
                  <Text as="span" variant="bodyMd">
                    {product.title}
                  </Text>
                  {exceptionList.includes(product.id) && (
                    <Badge status="warning">Excepted</Badge>
                  )}
                </Stack>
              </div>
            ))}
            {productsCount > 3 && (
              <Text variant="bodyMd" as="p">{`and ${productsCount - 3
                } more products targeted...`}</Text>
            )}
          </Stack>
        )}
      </LegacyCard.Section>
    </LegacyCard>
  );
};

export default CurrentSelectedProductsCard;